import { getUserProgramDetailPromise } from 'api/UserProgram'
import React, { useMemo, useState } from 'react'
import Form from './form'

export default function ProgramAdd (props) {
  const { id } = props.match.params
  const [data, setData] = useState({})

  useMemo(() => {
    if (!id) return

    getUserProgramDetailPromise(id).then(resp => {
      resp && setData(resp)
    })
  }, [id])

  return <Form data={data} setData={setData} {...props} />
}